/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * How the user signed up. Null if the source is unknown.
 */
export type SignupSource = (typeof SignupSource)[keyof typeof SignupSource];

export const SignupSource = {
  WEB_APP: "WEB_APP",
  MOBILE_APP: "MOBILE_APP",
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
} as const;
